/**
 * External dependencies
 */
import 'es6-symbol';

/**
 * Internal dependencies
 */
import { showPage } from './redirection';
import { getExpectedAlternativeUrl } from './url';

import { doSingleAction } from '../utils/actions';
import { doesVisitorParticipate } from '../utils/participation';
import { removeQueryArgs } from '../utils/url';
import {
	isVisitorInASegmentOfEveryTest,
	updateSegmentationSettings,
} from '../utils/segments';
import { maybeMarkSiteAsStaging } from '../utils/tracking';

let didInitRun = false;
export async function init( settings ) {
	if ( didInitRun ) {
		return;
	} //end if
	didInitRun = true;

	settings = {
		...settings,
		currentUrl: window.location.href,
		untestedUrl: removeQueryArgs( window.location.href, 'nab' ),
	};

	const participates = doesVisitorParticipate( settings );
	if ( ! participates ) {
		const { untestedUrl } = settings;
		return showPage( settings, untestedUrl );
	} //end if

	maybeMarkSiteAsStaging( settings );

	const { isTestedPostRequest } = settings;
	if ( isTestedPostRequest ) {
		const alternativeUrl = getExpectedAlternativeUrl( settings );
		return showPage( settings, alternativeUrl );
	} //end if

	const { experiments } = settings;
	await updateSegmentationSettings( settings, 'now' );
	if ( ! isVisitorInASegmentOfEveryTest( experiments ) ) {
		const { untestedUrl } = settings;
		return showPage( settings, untestedUrl );
	} //end if

	const alternativeUrl = getExpectedAlternativeUrl( settings );
	return showPage( settings, alternativeUrl );
} //end init()

doSingleAction( 'alt-loader-init-available' );
